export interface sessionData{
    status:boolean,
    userData:{
        userid:string,
        username:string,
        administrator:boolean,
        otpCode:boolean,
        empCode:string,
        alias:string|null,
        tpdata?:db_timepro_person,
        flags:{
            salaryResign:boolean,
        },
        proxyUserKey:string,
    }
}
export interface API_auth_req{
    userid:string|null,
    password:string|null,
    otpToken:string|null,
}
export interface apiResponseData_auth{
    status:boolean,//認証結果
    lock?:boolean,
    //以下認証結果=faleは入らない
    userid?:string,
    username?:string,
    administrator?:boolean,
    totp?:boolean,
    lastLogin?:string,
    tpdata?:db_timepro_person,
    flags?:{
        salaryResign:boolean,
    },
    proxyUserKey:string,
}
interface db_timepro_person{
    EmpCode:string,
    WordName:string,
    DepCodeAll:string,
    RetireFlag:number,
    RetireYMD:number,
    DepName:string,
    DepNameAll:string,
    BounusCount:number,
}
export interface apiResponseData_userFull {
    userid:string,
    username:string,
    empcode:string|null,
    useOtp:boolean,
    lastLogin:string|null,
    alias:string|null,
    ecAdmin?:boolean,
    ecAdress?:Array<adressDetail|null>,
    approvalRequest?:Array<approvalDetail_proxy>,
    allowChatUse?:0|1|2,//0:使用不可,1:可,2:見るだけ
}
interface adressDetail{
    type:AdressType,
    adress:string,
    conf:boolean,
    lineId?:string,
    lineRetryKey?:string|null,
    count?:number,
}
type AdressType = "mail"|"line"|"proxy";
export type ecAddressType = AdressType;
interface approvalDetail_proxy{
    type:"proxy",
    userId:string,
    userName:string,
    confCode:string
}
export interface PostAddressData{
    type:AdressType,
    adress:string
}
export interface API_passwordChange_Req{
    current:string|null,
    password:string|null,
    otpToken?:string|null,
}
export const ePasswordChangeStatus = {
    sccess:1,
    currentAuthFaild:-1,
}
export interface API_passwordChange_Res{
    status:number
}
export interface SalaAPI_TOTP_NewSecret_res{
    key:string
    url:string,
    qrcodeDataUrl:string,
}

export type ResEcEvents = Array<ecEvent>
export interface ecEvent{
    eventId:string,
    eventDate:Date,
    eventMode:number,
    alertInfo:AlertData,
}
export interface AlertData{
    type:"manual"|"training"|"earthquake"|"tsunami"|"messege",
    earthquake?:{
        maxInt:number,
        area:string,
        maxIntText:string,
        targetDate:Date,
        title:string,
    },
    training?:{
        messege:string,
    },
    manual?:{
        subject:string,
        messege:string,
    },
    messege?:{
        txt:string
    }
}
export interface EcReportResponse{
    report:Array<EcReport>,
    memo:Array<EcMemo>|null,
    flags:{unanswer:boolean}
}
export interface EcReport{
    reportID:string,
    eventId:string,
    userId:string,
    answerUserID:string|null,
    answerUserName:string|null,
    answerUserDepname:string|null,
    userName?:string,
    depName?:string,
    detail:Array<ReportQuColumn>,
    UP_DATE:Date|null,
}
export interface ReportQuColumn{
    type:"select"|"text",
    title:string,
    selectItem?:Array<string>,
    required:boolean,
    value?:any,
}
interface EcMemo{
    reportID:string,
    createDate:string,
    createUserID:string|null,
    createUserName:string|null,
    createUserDepname:string|null,
    messege:string,
}
export interface EcChat{
    seqNo:number,
    eventID:string,
    createDate:string,
    createUserID:string|null,
    createUserName:string|null,
    createUserDepname:string|null,
    messege:string,
}
export type apiResponseData_ecusers = Array<apiResponseData_user>;
export interface apiResponseData_user{
    userid:string,
    username:string,
    empcode:string,
    useOtp:boolean,
    lastLogin:string|null,
    alias:string|null,
    ecAdmin?:boolean,
    adressReg:boolean,
    addressDetail:AddressDetails,
    depname:string|null,
    exView:exView|null,
}
export type AddressDetails = Array<{
    type:adressType,
    status:boolean,
    proxySrver?:{
        retire:boolean,
        userid:string,
        username:string,
        empcode:string,
        depname:string,
    }
}>
export type adressType = "mail"|"line"|"proxy";
export type exView = {
    allow:Array<string>,
    forbid:Array<string>,
}
export interface admin_getEcConfig{
    ecAlert:{
        mode:0|1, //0:通常,1:安否確認稼働中
        conifg:{
            trigerTime:number,
            condition:{
                quake:Array<{
                int:string,
                area:string,
            }>}
        }
    },
    messege:{
        EC_MessegeTitle:string,
        EC_Messege_Precall:string,
        EC_Messege_Call:string,
        EC_Messege_Proxy:string,
    },
    reportColumn:Array<ReportQuColumn>,
    ecMessegeExclusion:Array<string>,
    depertmentList:Array<{code:string,fullname:string,shortname:string}>,
    jmaArea:Array<{
        ACODE:string,
        ANAME:string,
    }>,
}
export type EcAlertConfig = {area:string|null,condition:ecDbCondt};
type ecDbCondt = type_0_systmCondition|type_1_quakeCondition;
interface type_0_systmCondition{
    trigerTime:number
}
interface type_1_quakeCondition{
    maxInt:string
}
export interface EcViewList{
    userlist: string[];
    deplist: string[];
}

export interface EventRequestDetal{
    "key":string,
    "type":"training"|"manual",
    "messege":string,
    "subject":string
}
export interface MessegeTemplete{
    id: number;
    name: string;
    text: string;
}
